import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { Modal } from './Modal';
import { StartPlanDialog } from './StartPlanDialog';

// Start a scout planning session from the console (arc 101 slice 07) — the
// human door onto `POST /v1/plans` and the flat `plan_start` MCP verb.
//
// This shell owns exactly one thing, the dialog chrome, so that the GUTS mount
// only while the dialog is on screen — the <CommandPalette/> split, for the same
// reason it exists there. <StartPlanDialog/> holds the exhaust walk of
// `/v1/repos` that fills the picker, and an always-mounted copy would put that
// walk on every visit to `/fleet/plans`, opened or not. `<Modal/>` reads its
// children inside its own visibility `<Show>`, so the split is the whole fix:
// nothing here has to duplicate the exit animation.

export type StartPlanModalProps = {
  readonly open: boolean;
  readonly token: string | null;
  readonly onClose: () => void;
};

export function StartPlanModal(props: StartPlanModalProps): JSX.Element {
  return (
    <Modal
      open={props.open}
      size="lg"
      title={t('fleet.plans.start.title')}
      desc={t('fleet.plans.start.intro')}
      onClose={props.onClose}
    >
      <StartPlanDialog token={props.token} onClose={props.onClose} />
    </Modal>
  );
}
